module.exports = __webpack_public_path__ + "img/seal.8f7f7a29.png";